import axios, { AxiosError } from "axios";
const CustomerVehicleResource = {
    get(customerId, customerVehicleId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/${customerId}/vehicles/${customerVehicleId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(customerId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/customers/${customerId}/vehicles/`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(customerId, customerVehicleId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/customers/${customerId}/vehicles/${customerVehicleId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    delete(customerId, customerVehicleId, disableAt, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/customers/${customerId}/vehicles/${customerVehicleId}`, { params: { disableAt } })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    createTare(customerId, customerVehicleId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/customers/${customerId}/vehicles/${customerVehicleId}/tares`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default CustomerVehicleResource;
